module.exports = __webpack_public_path__ + "static/img/5.1013c8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/5.png
// module id = 5a6b
// module chunks = 0